import { render, staticRenderFns } from "./OrderRefundsShow.vue?vue&type=template&id=079cdf48"
import script from "./OrderRefundsShow.vue?vue&type=script&lang=js"
export * from "./OrderRefundsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports